'use client';

import { c as _c } from "react/compiler-runtime";
import { CardSlider, CardSliderHeader, CardSliderList, CardSliderListItem, CardSliderSeeAllButton, CardSliderTitle } from '@7f-ui/components/card-slider/card-slider';
import { useClientMediaState } from '@7f-ui/hooks/use-media-state';
import type { NexperienceSearchItemFragment } from '@data-access/lib/gql/experience/documents';
import { ExperienceCard } from '@feat/feat-experience/cards';
import { trackPartnerProfileExperienceClick } from '@feat/feat-tracking/partner-profile';
import { useState } from 'react';
import { getPartnerExperiencesBreakpoint, getVisiblePartnerExperiencesCount } from '../_lib/partner-experiences-visibility';
type PartnerExperiencesProps = {
  title: string;
  merchantPublicId: number;
  experiences: NexperienceSearchItemFragment[];
};
export function PartnerExperiences(t0) {
  const $ = _c(40);
  const {
    title,
    merchantPublicId,
    experiences
  } = t0;
  const isSm = useClientMediaState("sm");
  const isMd = useClientMediaState("md");
  const [showAll, setShowAll] = useState(false);
  if (experiences.length === 0) {
    return null;
  }
  let T0;
  let T1;
  let hasMore;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== experiences || $[1] !== isMd || $[2] !== isSm || $[3] !== merchantPublicId || $[4] !== showAll || $[5] !== title) {
    const breakpoint = getPartnerExperiencesBreakpoint(isSm, isMd);
    const visibleCount = getVisiblePartnerExperiencesCount(experiences.length, breakpoint, showAll);
    const visibleExperiences = experiences.slice(0, visibleCount);
    hasMore = visibleExperiences.length < experiences.length;
    T1 = CardSlider;
    t4 = !isMd;
    let t6;
    if ($[14] !== title) {
      t6 = <CardSliderTitle>{title}</CardSliderTitle>;
      $[14] = title;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    let t7;
    if ($[16] !== hasMore || $[17] !== isMd || $[18] !== isSm) {
      t7 = isSm && !isMd && hasMore && <CardSliderSeeAllButton onClick={() => setShowAll(true)}>{"Alle Erlebnisse anzeigen"}</CardSliderSeeAllButton>;
      $[16] = hasMore;
      $[17] = isMd;
      $[18] = isSm;
      $[19] = t7;
    } else {
      t7 = $[19];
    }
    if ($[20] !== t6 || $[21] !== t7) {
      t5 = <div className="px-6 md:px-0"><CardSliderHeader>{t6}{t7}</CardSliderHeader></div>;
      $[20] = t6;
      $[21] = t7;
      $[22] = t5;
    } else {
      t5 = $[22];
    }
    T0 = CardSliderList;
    t1 = !isSm;
    t2 = "px-6 md:grid-cols-2 md:gap-6 md:px-0";
    let t8;
    if ($[23] !== isSm || $[24] !== merchantPublicId) {
      t8 = experience => <CardSliderListItem key={experience.id}><ExperienceCard experience={experience} isFixedWidth={!isSm} disableSlider={!isSm} onClick={() => trackPartnerProfileExperienceClick(merchantPublicId, experience.publicId)} /></CardSliderListItem>;
      $[23] = isSm;
      $[24] = merchantPublicId;
      $[25] = t8;
    } else {
      t8 = $[25];
    }
    t3 = visibleExperiences.map(t8);
    $[0] = experiences;
    $[1] = isMd;
    $[2] = isSm;
    $[3] = merchantPublicId;
    $[4] = showAll;
    $[5] = title;
    $[6] = T0;
    $[7] = T1;
    $[8] = hasMore;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    T0 = $[6];
    T1 = $[7];
    hasMore = $[8];
    t1 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
  }
  let t6;
  if ($[26] !== T0 || $[27] !== t1 || $[28] !== t2 || $[29] !== t3) {
    t6 = <T0 isSlidable={t1} className={t2}>{t3}</T0>;
    $[26] = T0;
    $[27] = t1;
    $[28] = t2;
    $[29] = t3;
    $[30] = t6;
  } else {
    t6 = $[30];
  }
  let t7;
  if ($[31] !== hasMore || $[32] !== isMd) {
    t7 = isMd && hasMore && <div className="grid px-6 md:justify-start md:px-0"><CardSliderSeeAllButton onClick={() => setShowAll(true)}>{"Alle Erlebnisse anzeigen"}</CardSliderSeeAllButton></div>;
    $[31] = hasMore;
    $[32] = isMd;
    $[33] = t7;
  } else {
    t7 = $[33];
  }
  let t8;
  if ($[34] !== T1 || $[35] !== t4 || $[36] !== t5 || $[37] !== t6 || $[38] !== t7) {
    t8 = <T1 fullBleed={t4}>{t5}{t6}{t7}</T1>;
    $[34] = T1;
    $[35] = t4;
    $[36] = t5;
    $[37] = t6;
    $[38] = t7;
    $[39] = t8;
  } else {
    t8 = $[39];
  }
  return t8;
}